module.exports = __webpack_public_path__ + "img/wallpaper3.797188ba.png";